var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecipesGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon recipe black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-recipe-black"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 50 0 50 50 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8112417,26.780722 L22.9914308,21.5733906 L10.141633,8.67466532 C7.28612234,11.5451377 7.28612234,16.2004551 10.141633,19.089328 L17.8112417,26.780722 Z M30.2217302,23.450238 C33.0223271,24.7566709 36.9578065,23.8366477 39.8682308,20.9109739 C43.3644009,17.3964853 44.0416694,12.3547581 41.3508998,9.64988992 C38.6784347,6.96342217 33.6629866,7.62583887 30.1485119,11.1403275 C27.2380876,14.0660013 26.3228599,18.0221011 27.6224833,20.8373721 L9.75723731,38.796225 L12.3381796,41.3906904 L24.9500182,28.7495716 L37.5435523,41.4090909 L40.1244946,38.8146255 L27.5309605,26.1551062 L30.2217302,23.450238 Z",
    id: "Shape",
    fill: "#505050",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipesGrey);
export default __webpack_public_path__ + "static/media/recipes-grey.02def5401acd2e26b45eca596c1766d8.svg";
export { ForwardRef as ReactComponent };